// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3yHWE","topBottomGutter":"Layout_topBottomGutter__1j0p5"};